import { useState, useCallback } from "react";

type UseAsyncActionProps<T extends (...args: any[]) => Promise<any>> = {
  asyncFn: T;
  minDelay?: number;
};

export const useAsyncAction = <T extends (...args: any[]) => Promise<any>>(
  props: UseAsyncActionProps<T>
) => {
  const { asyncFn, minDelay } = props;
  const [loading, setLoading] = useState(false);

  const execute = useCallback(
    async (...args: Parameters<T>): Promise<ReturnType<T>> => {
      setLoading(true);
      const startTime = Date.now();
      try {
        const result = await asyncFn(...args);
        if (minDelay) {
          const elapsed = Date.now() - startTime;
          if (elapsed < minDelay) {
            await new Promise((resolve) =>
              setTimeout(resolve, minDelay - elapsed)
            );
          }
        }
        setLoading(false);
        return result;
      } catch (error) {
        if (minDelay) {
          const elapsed = Date.now() - startTime;
          if (elapsed < minDelay) {
            await new Promise((resolve) =>
              setTimeout(resolve, minDelay - elapsed)
            );
          }
        }
        setLoading(false);
        throw error;
      }
    },
    [asyncFn, minDelay]
  );

  return { execute, loading };
};
